module.exports = __webpack_public_path__ + "img/Cody_Lohnes.888aba94.png";